import Layout from '../components/layouts/AppLayout'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'
import { useMutation } from '@apollo/client'
import { FORGOT_PASSWORD } from '../services/graphql/mutations/forgotPassword'
import Image from 'next/future/image'
import { toast } from 'react-toastify'

export default function Recovery () {
  const { t } = useTranslation(['recovery'])
  const [sendRecovery] = useMutation(FORGOT_PASSWORD)
  const [email, setEmail] = useState('')
  const router = useRouter()

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      await sendRecovery({
        variables: {
          input: {
            email,
            reset_password_url: {
              url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/password-reset?email=__EMAIL__&token=__TOKEN__`
            }
          }
        }
      })

      toast.success(t('recovery.alerts.success'))
    } catch (e) {
      toast.error(t('recovery.alerts.error'))
    }
  }

  return (
    <Layout variant="light-blue">
      <Head>
        <title>{t('recovery.meta.title')}</title>
      </Head>
      <div className="bg-light-blue py-lg-5">
        <div className="container py-lg-5 py-3">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-4 col-12 text-center">
              <Image
                src="/images/logo.svg"
                width={200}
                height={150}
                alt=""
              />
            </div>
          </div>
          <div className="row justify-content-center align-items-center">
            <form
              onSubmit={e => handleSubmit(e)}
              className={'bg-white shadow-sm rounded appendix px-4 py-5 col-lg-4 col-12 login__appendix'}
            >
              <h2 className="fs-3 mb-3 fw-bold text-dark">{t('recovery.title')}</h2>
              <div className="form-group mt-3">
                <label className="form-label"
                  htmlFor="email"
                >{t('inputs.email')}</label>
                <input required
                  type="email"
                  className="form-control"
                  id="email"
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              <button type="submit"
                className="btn btn-primary mt-4 w-100"
              >{t('reset', { ns: 'common' })}</button>
              <button
                type="button"
                onClick={() => router.back()}
                className="btn btn-outline-primary mt-4 w-100"
              >{t('back', { ns: 'common' })}</button>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export async function getServerSideProps ({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['recovery', 'header', 'footer', 'languages', 'common', 'applications', 'routes']))
    }
  }
}
